<template>
  <v-dialog persistent v-model="mostrarPreferenciasUsuario" max-width="700px">
    <v-card>
      <v-card-title>Cambiar datos de usuario</v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12"
              ><v-text-field
                disabled
                label="Usuario"
                v-model="objetoPreferenciasUsuario.Usuario"
              ></v-text-field
            ></v-col>
            <v-col v-if="1==2" cols="12"
              ><v-text-field
                clearable
                label="Correo electrónico"
                v-model="objetoPreferenciasUsuario.Email"
              ></v-text-field
            ></v-col>
            <v-col cols="12"
              ><v-text-field
                clearable
                :append-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword1 ? 'text' : 'password'"
                @click:append="showPassword1 = !showPassword1"
                label="Nueva contraseña"
                v-model="objetoPreferenciasUsuario.PasswordNueva"
                :error-messages="passwordNuevaErrors"
                @input="$v.objetoPreferenciasUsuario.PasswordNueva.$touch()"
                @blur="$v.objetoPreferenciasUsuario.PasswordNueva.$touch()"
              ></v-text-field
            ></v-col>
            <v-col cols="12"
              ><v-text-field
                clearable
                :append-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword3 ? 'text' : 'password'"
                @click:append="showPassword3 = !showPassword3"
                label="Confirmar nueva contraseña"
                v-model="objetoPreferenciasUsuario.confirmarPassword"
                :error-messages="confirmarpasswordNuevaErrors"
                @input="$v.objetoPreferenciasUsuario.confirmarPassword.$touch()"
                @blur="$v.objetoPreferenciasUsuario.confirmarPassword.$touch()"
              ></v-text-field
            ></v-col>
            <v-col cols="12"
              ><v-text-field
                clearable
                :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword2 ? 'text' : 'password'"
                @click:append="showPassword2 = !showPassword2"
                :error-messages="passwordErrors"
                @input="$v.objetoPreferenciasUsuario.Password.$touch()"
                @blur="$v.objetoPreferenciasUsuario.Password.$touch()"
                label="Contraseña actual"
                v-model="objetoPreferenciasUsuario.Password"
              ></v-text-field
            ></v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" @click="ocultaModalCambiodeContrasena()" text>Cancelar</v-btn>
        <v-btn color="blue darken-1" @click="confirmaCambiarPreferencias()" text>Aceptar</v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar
      v-model="snackbarExito"
      timeout="2000"
      rounded="pill"
      centered
      elevation="8"
      color="blue darken-1"
      ><span style="font-size:20px;">
        {{ mensajeSnackbarExito }} <v-icon medium> mdi-check-circle </v-icon>
      </span></v-snackbar
    >
    <ModalErrorEnAccion
      :mensajeError="mensajeErrorModalErrorEnAccion"
      :show="dialogErrorEnAccion"
      @cerrarModalEnAccion="dialogErrorEnAccion = false"
    />
  </v-dialog>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { required, sameAs } from "vuelidate/lib/validators";
import ModalErrorEnAccion from "@/components/modales/ModalErrorEnAccion.vue";

export default {
  components: {
    ModalErrorEnAccion
  },
  validations: {
    objetoPreferenciasUsuario: {
      confirmarPassword: {
        sameAsPassword: sameAs("PasswordNueva")
      },
      Email: {
        emailValida(Email) {
          return true;
        }
      },
      Password: {
        required
        // passwordValida(Password) {
        //   if (!this.passwordNuevaVacia && this.passwordVacia) {
        //     return false;
        //   } else {
        //     return true;
        //   }
        // }
      },
      PasswordNueva: {
        // passwordValida(PasswordNueva) {
        //   if (this.passwordNuevaVacia && !this.passwordVacia) {
        //     return false;
        //   } else {
        //     return true;
        //   }
        // }
      }
    }
  },
  props: {
    mostrarPreferenciasUsuario: Boolean
  },
  data: () => ({
    dialogErrorEnAccion: false,
    snackbarExito: false,
    mensajeErrorModalErrorEnAccion: "",
    mensajeSnackbarExito: "",
    objetoPreferenciasUsuario: {
      Usuario: "",
      Password: "",
      Email: "",
      PasswordNueva: "",
      confirmarPassword: ""
    },
    showPassword1: false,
    showPassword2: false,
    showPassword3: false
  }),
  mounted() {
    this.objetoPreferenciasUsuario.Usuario = this.logedInUserInfo.usuario;
  },
  methods: {
    ...mapActions("sesion", ["cambiarDatosUsuario"]),
    async confirmaCambiarPreferencias() {
      this.$v.$touch();
      if (this.$v.$invalid) {
      } else {
        if (
          this.objetoPreferenciasUsuario.Email == null ||
          this.objetoPreferenciasUsuario.Email == ""
        ) {
          delete this.objetoPreferenciasUsuario.Email;
        }
        delete this.objetoPreferenciasUsuario.confirmarPassword;
        const res = await this.cambiarDatosUsuario(this.objetoPreferenciasUsuario);
        if (res[0] == true) {
          await this.delayMostrarMensajesExito(res[1]);
          // await this.$emit("ocultaModalCambiodeContrasena");
        } else {
          this.mensajeErrorModalErrorEnAccion = res[1];
          this.dialogErrorEnAccion = true;
        }
      }
    },
    delayMostrarMensajesExito(msg) {
      this.snackbarExito = true;
      this.mensajeSnackbarExito = msg;
    },
    ocultaModalCambiodeContrasena() {
      this.$emit("ocultaModalCambiodeContrasena");
    }
  },
  computed: {
    ...mapState({
      logedInUserInfo: state => state.sesion.logedInUserInfo
    }),
    passwordNuevaVacia() {
      if (
        this.objetoPreferenciasUsuario.PasswordNueva == null ||
        this.objetoPreferenciasUsuario.PasswordNueva == ""
      ) {
        return true;
      } else {
        return false;
      }
    },
    passwordVacia() {
      if (
        this.objetoPreferenciasUsuario.Password == null ||
        this.objetoPreferenciasUsuario.Password == ""
      ) {
        return true;
      } else {
        return false;
      }
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.objetoPreferenciasUsuario.Password.$dirty) return errors;
      !this.$v.objetoPreferenciasUsuario.Password.required &&
        errors.push("El campo contraseña actual es requerido.");
      return errors;
    },
    passwordNuevaErrors() {
      const errors = [];
      if (!this.$v.objetoPreferenciasUsuario.PasswordNueva.$dirty) return errors;
      return errors;
    },
    confirmarpasswordNuevaErrors() {
      const errors = [];
      if (!this.$v.objetoPreferenciasUsuario.confirmarPassword.$dirty) return errors;
      !this.$v.objetoPreferenciasUsuario.confirmarPassword.sameAsPassword &&
        errors.push("Las contraseñas deben coincidir.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.objetoPreferenciasUsuario.Email.$dirty) return errors;
      !this.$v.objetoPreferenciasUsuario.Email.emailValida &&
        errors.push("El campo email no es valida.");
      return errors;
    }
  }
};
</script>
